import { useBooleanFlagValue } from '@openfeature/react-sdk';

export const CUA_WAKE_ASSERTION_FLAG_KEY = 'release-apps-cua-wake-assertion-desktop';

export const useIsCuaWakeAssertionEnabled = (): boolean =>
  useBooleanFlagValue(CUA_WAKE_ASSERTION_FLAG_KEY, false);
